/**
 * FlyFreely API
 *
 * Contact: support@flyfreely.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MissionApprovalActions } from './missionApprovalActions';
import { SimplePersonDto } from './simplePersonDto';

export interface RequestersMissionApprovalDto {
    /**
     * The unique ID of the approval
     */
    id: number;
    /**
     * The current status of the approval
     */
    status: RequestersMissionApprovalDto.Status;
    /**
     * A message from the approver to the RPIC when approving the mission
     */
    messageFromApprover?: string;
    /**
     * The maximum permitted height of operations in feet
     */
    maximumHeight?: number;
    /**
     * The time that the approval was originally requested
     */
    requestTime?: string;
    /**
     * The person who requested this approval
     */
    requestedBy?: SimplePersonDto;
    /**
     * The time the approval was either approved or cancelled
     */
    resolutionTime?: string;
    /**
     * The person who approved this approval
     */
    approvedBy?: SimplePersonDto;
    /**
     * A list of conditions imposed by the approver
     */
    conditions?: Array<any>;
    /**
     * The person who accepted the approval
     */
    acceptedBy?: SimplePersonDto;
    /**
     * The time that the approval was accepted
     */
    acceptTime?: string;
    /**
     * ${swagger.MissionApproval.authorityWorkflowVersionId}
     */
    authorityWorkflowVersionId: number;
    /**
     * ${swagger.MissionApproval.authorityId}
     */
    authorityId: number;
    /**
     * The timestamp when the entity was first stored
     */
    creationTime: string;
    /**
     * ${swagger.Generic.creationBy}
     */
    creationById?: number;
    /**
     * The timestamp when the entity was last stored
     */
    modificationTime?: string;
    /**
     * ${swagger.Generic.modificationBy}
     */
    modificationById?: number;
    /**
     * The actions that can be performed by the current user
     */
    availableActions: MissionApprovalActions;
    rpicSignature?: string;
    approverSignature?: string;
}
export namespace RequestersMissionApprovalDto {
    export type Status =
        | 'DRAFT'
        | 'PENDING'
        | 'BEING_REVIEWED'
        | 'REVISION_REQUIRED'
        | 'APPROVED'
        | 'REJECTED'
        | 'CANCELLED'
        | 'ACCEPTED'
        | 'REVOKED';
    export const Status = {
        DRAFT: 'DRAFT' as Status,
        PENDING: 'PENDING' as Status,
        BEING_REVIEWED: 'BEING_REVIEWED' as Status,
        REVISION_REQUIRED: 'REVISION_REQUIRED' as Status,
        APPROVED: 'APPROVED' as Status,
        REJECTED: 'REJECTED' as Status,
        CANCELLED: 'CANCELLED' as Status,
        ACCEPTED: 'ACCEPTED' as Status,
        REVOKED: 'REVOKED' as Status
    };
}
